import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@michelin/central-provider';
import { Fab, GlobalActions } from '@michelin/acid-components';
import {
  Add,
  DoneAll,
  Remove,
  Timelapse,
} from '@material-ui/icons';
import { CommercialContext } from '../MassSTUpdate/Commercial/index';

interface GenericActionButtonsMassUpdateProps {
  isDirty: boolean,
  getValues: any,
  reset: any,
  handleSubmit: any,
  validateAction: string,
  hideAdd?: boolean,
  hideRemove?: boolean,
}

export function GenericActionButtonsMassUpdate({
  isDirty, getValues, reset, validateAction, handleSubmit, hideAdd, hideRemove,
}: GenericActionButtonsMassUpdateProps) {
  const permissions = usePermissions();
  const { t } = useTranslation();
  const context = useContext(CommercialContext);

  if (!permissions.allowsAction(validateAction)) return null;

  function getDescription(message: string) {
    return (context?.selectedCount || 0) > 0
      ? t(message, { count: context?.selectedCount || 0 })
      : t('Select at least one location');
  }

  return (
    <GlobalActions>
      <Fab
        color="inherit"
        aria-label={t('Saving')}
        disabled
        displayDisabled={context?.isLoading || false}
      >
        <Timelapse />
      </Fab>
      {!hideRemove && (
        <Fab
          color={isDirty && (context?.selectedCount || 0) > 0 ? 'primary' : 'inherit'}
          aria-label={getDescription('Remove selected information from {{count}} location(s)')}
          onClick={handleSubmit(() => context?.onSave('remove', isDirty, getValues(), reset), context?.onError)}
          disabled={context?.isLoading}
        >
          <Remove />
        </Fab>
      )}
      {!hideAdd && (
        <Fab
          color={isDirty && (context?.selectedCount || 0) > 0 ? 'primary' : 'inherit'}
          aria-label={getDescription('Add selected information to {{count}} location(s)')}
          onClick={handleSubmit(() => context?.onSave('add', isDirty, getValues(), reset), context?.onError)}
          disabled={context?.isLoading}
        >
          <Add />
        </Fab>
      )}
      <Fab
        color={isDirty && (context?.selectedCount || 0) > 0 ? 'primary' : 'inherit'}
        aria-label={getDescription('Add Selected & Remove Un-Selected information for {{count}} location(s)')}
        onClick={handleSubmit(() => context?.onSave('all', isDirty, getValues(), reset), context?.onError)}
        disabled={context?.isLoading}
      >
        <DoneAll />
      </Fab>
    </GlobalActions>
  );
}
